import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import NewRelesesAll from '../pages/NewRelesesAll';
import BookOverviewResults from '../pages/BookOverviewResults';
import ExamwiseBooks from '../pages/ExamwiseBooks';
import Result from '../pages/Result';
import Contactus from '../pages/Contactus';
import AllCombos from '../pages/AllCombos';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PopularCategoryAll from '../pages/PopularCatogoryAll';
import Blog from '../pages/Blog';
import Aboutus from '../pages/Aboutus';
import Faq from '../pages/Faq';
import Home from '../pages/Home/Home';
import FilteredBooks from '../pages/FilteredBooks';
import ShippingCart from '../pages/ShippingCart';
import BreadcrumbsNav from '../pages/BreadcrumbsNav';
import PageNotFound from '../pages/PageNotFound';
import Checkout from '../pages/Checkout';
import Terms from '../pages/Terms';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Catogoryblog from '../pages/Catogoryblog';
import ExchangePolicy from '../pages/ExchangePolicy';
import MyProfile from '../pages/MyProfile/MyProfile';
import LoginMobile from '../pages/LoginMobile';
import RegisterMobile from '../pages/RegisterMobile';
import MyProfileInfo from '../pages/MyProfile/MyProfileInfo';
import MyOrders from '../pages/MyProfile/MyOrders';
import ShippingDetails from '../pages/MyProfile/ShippingDetails';
import ProtectedRoutes from './ProtectedRoutes';

const PageRoutes = () => {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <BreadcrumbsNav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book-overview/:id" element={<BookOverviewResults type="book" />} />
        <Route path="/combo-overview/:id" element={<BookOverviewResults type="combo" />} />
        <Route path="/books" element={<ExamwiseBooks />} />
        <Route path="/books/:catname" element={<ExamwiseBooks />} />
        <Route path="/filtered-books" element={<FilteredBooks />} />
        <Route path="/NewReleases" element={<NewRelesesAll />} />
        <Route path="/AllCombos" element={<AllCombos />} />
        <Route path="/popular-categories" element={<PopularCategoryAll />} />
        <Route path="/result" element={<Result />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/category-blog/:id" element={<Catogoryblog />} />
       
        <Route path="/faq" element={<Faq />} />
        <Route path="/my-profile" element={
          <ProtectedRoutes>
            <MyProfile />
          </ProtectedRoutes>
        }>
          <Route index element={<MyProfileInfo />} />
          <Route path="orders" element={<MyOrders />} />
          <Route path="shipping" element={<ShippingDetails />} />
        </Route>

        <Route path="/about" element={<Aboutus />} />
        <Route path="/login" element={<LoginMobile />} />
        <Route path="/register" element={<RegisterMobile />} />

        <Route path="/cart" element={<ProtectedRoutes><ShippingCart /></ProtectedRoutes>} />
        <Route path="/checkout" element={<ProtectedRoutes><Checkout /></ProtectedRoutes>} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/exchange-policy" element={<ExchangePolicy />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {location.pathname === '/' ? <Footer news={true} /> : <Footer />}
    </>
  );
};

export default PageRoutes;
